module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-46.f9aa69ad.svg";